export const featuredItems = [
  {
    category: "Sneakers",
    products: "2,000+",
    updated: "Weekly",
    popularity: "High",
    description: "The most active category with fresh sneaker finds dropping every week. From retro runners to modern basketball silhouettes.",
    image: "https://readdy.ai/api/search-image?query=Closeup%20of%20a%20single%20premium%20running%20sneaker%20in%20cream%20and%20olive%20green%20colorway%20on%20a%20minimalist%20white%20pedestal%20with%20dramatic%20top-down%20lighting%20casting%20a%20soft%20glow%2C%20luxury%20product%20photography%2C%20sweat%20beads%20on%20surface%2C%20no%20text%2C%20performance%20aesthetic&width=800&height=1067&seq=feat-sneakers-v2-p&orientation=portrait",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
  },
  {
    category: "Luxury Bags",
    products: "800+",
    updated: "Weekly",
    popularity: "High",
    description: "Curated selection of premium handbags and totes. Every listing verified for authenticity and seller reputation.",
    image: "https://readdy.ai/api/search-image?query=Elegant%20suede%20bucket%20bag%20in%20dusty%20rose%20pink%20with%20gold%20chain%20detail%20placed%20on%20a%20polished%20travertine%20surface%20near%20a%20sunlit%20window%2C%20editorial%20photography%2C%20soft%20shadows%2C%20no%20text%2C%20feminine%20luxury%20aesthetic&width=800&height=1067&seq=feat-bags-v2-q&orientation=portrait",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
  },
  {
    category: "Hoodies",
    products: "1,500+",
    updated: "Weekly",
    popularity: "High",
    description: "Oversized fits, heavyweight cotton, and limited drops. The streetwear category that never sleeps.",
    image: "https://readdy.ai/api/search-image?query=Heavyweight%20brushed%20fleece%20hoodie%20in%20charcoal%20grey%20draped%20casually%20over%20a%20mid-century%20modern%20armchair%2C%20warm%20reading%20lamp%20glow%2C%20editorial%20interior%20photography%2C%20cozy%20texture%20visible%2C%20no%20text%2C%20autumn%20comfort%20aesthetic&width=800&height=1067&seq=feat-hoodies-v2-r&orientation=portrait",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
  },
  {
    category: "Electronics",
    products: "500+",
    updated: "Monthly",
    popularity: "Medium",
    description: "Carefully vetted gadgets and tech accessories. Every device link checked for working condition and seller history.",
    image: "https://readdy.ai/api/search-image?query=Sleek%20matte%20black%20wireless%20headphones%20resting%20on%20a%20white%20ceramic%20tray%20next%20to%20a%20small%20potted%20snake%20plant%2C%20clean%20morning%20light%2C%20modern%20minimalist%20product%20photography%2C%20no%20text%2C%20contemporary%20workspace%20aesthetic&width=800&height=1067&seq=feat-electronics-v2-s&orientation=portrait",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
  },
];